import React from 'react';
import PropTypes from 'prop-types';

const Loading = ({ isVisible }) => (
  <p className="circle ">
    <span className={`ouro ouro3 ${isVisible ? 'invisible' : ''}`}>
      <span className="left"><span className="anim" /></span>
      <span className="right"><span className="anim" /></span>
    </span>
  </p>
);

Loading.defaultProps = {
  isVisible: 0
};

Loading.propTypes = {
  isVisible: PropTypes.number
};

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading/index.js